import React from "react";
import {observer} from "mobx-react";
import {Space, Table, Typography} from "antd";
import {useArticle} from "../../../article.context";
import {useTranslate} from "../../../../../../hooks/translate.hook";
import {columnsFactory} from "./article.data.oem.columns";

export const ArticleDataOem: React.FC = observer(() => {
    const {article} = useArticle();
    const t = useTranslate();
    const columns = columnsFactory(t);

    return (
        <Space direction={"vertical"} size={0}>
            <Typography.Title level={3}>{t("ARTICLES.OEM")}</Typography.Title>
            <Table
                columns={columns}
                rowKey={"id"}
                dataSource={[...article.oem]}
                scroll={{x: true}}
                pagination={false}
            />
        </Space>
    );
})
